export default __webpack_public_path__ + "static/logo-stacked-15a9ba1c9a3eb64f56e3a2704eb31c2e.svg";